<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import Pagination from '../../UI/Navigation/Pagination.vue'
import ContractDeliveryOrderListItem from './ContractDeliveryOrderListItem.vue'

export default {
  components: {
    ContractDeliveryOrderListItem,
    Pagination,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    deliveryOrders: { type: Object, required: true },
    contractNumber: { type: String, default: '' },
    contractId: { type: Number, required: true },
    uuid: { type: String, required: false },
  },

  emits: ['reload-delivery'],

  data: function () {
    return {
      selected: 3,
      deliveries: [],
    }
  },

  methods: {
    listView: function (list) {
      this.deliveries = list
    },
    setDeliveryOrder(deliveryOrder) {
      const index = this.deliveries.findIndex(({ id }) => deliveryOrder.id === id)
      if (index !== -1) {
        this.deliveries[index] = deliveryOrder
      }
    },
  },

  beforeMount: function () {
    this.deliveries = this.deliveryOrders
  },
}
</script>
<template>
  <div id="deliveries" class="card">
    <template v-for="delivery in deliveries" :key="delivery.id">
      <ContractDeliveryOrderListItem
        :delivery="delivery"
        :contract-id="contractId"
        :contract-number="contractNumber"
        :uuid="uuid"
        @update="setDeliveryOrder($event)"
        @reload="$emit('reload-delivery', delivery.id)"
      />
    </template>

    <div class="row d-flex justify-content-center mt-3">
      <Pagination
        v-if="deliveryOrders.length > selected"
        :datas="deliveryOrders"
        :max-per-page="selected"
        @show-list="listView"
      />
    </div>
  </div>
</template>
